import React, { useState } from "react";

interface Props {
  onClose: () => void;
}

/**
 * "Before You Continue" — shown before sending the user to the
 * TubeDealer seller sign-up screen.  Explains the free trial,
 * collects a terms tick, then redirects to /tubescan/?register=true.
 */
export default function TrialTermsModal({ onClose }: Props) {
  const [agreed, setAgreed] = useState(false);

  function accept() {
    if (!agreed) return;
    window.location.href = "/tubescan/?register=true";
  }

  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 9000,
        background: "rgba(0,0,0,0.85)", backdropFilter: "blur(4px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#141414", border: "1px solid #2a2a2a", borderRadius: 18,
          padding: "36px 28px 28px", maxWidth: 420, width: "100%",
          boxShadow: "0 24px 64px rgba(0,0,0,0.85)",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          position: "relative",
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Close × */}
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: 14, right: 14,
            background: "none", border: "none", color: "#555",
            fontSize: 20, cursor: "pointer", lineHeight: 1, padding: 4,
            borderRadius: 6,
          }}
          aria-label="Close"
        >
          ×
        </button>

        <div style={{ fontSize: 32, marginBottom: 12, textAlign: "center" }}>📋</div>

        <h2 style={{ fontSize: 20, fontWeight: 800, color: "#fff", margin: "0 0 8px", textAlign: "center" }}>
          Before You Continue
        </h2>

        <p style={{ fontSize: 13, color: "#777", lineHeight: 1.65, margin: "0 0 22px", textAlign: "center" }}>
          TubeDealer's scanning tool is free for 5 days, then{" "}
          <strong style={{ color: "#ccc" }}>$30/month</strong> (500 scans included).{" "}
          No credit card required to start.
        </p>

        {/* What's included */}
        <div style={{
          background: "#0d1a0d", border: "1px solid #1f4d1f",
          borderRadius: 11, padding: "14px 16px", marginBottom: 22,
        }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#4caf50", marginBottom: 10 }}>
            What's included in your free trial:
          </div>
          {[
            "Full tube scanner — camera, photo &amp; video",
            "Market sold price lookup",
            "Inventory system &amp; offer management",
            "No credit card required to start",
          ].map(f => (
            <div
              key={f}
              style={{ display: "flex", gap: 9, fontSize: 13, color: "#999", marginBottom: 6, alignItems: "flex-start" }}
              dangerouslySetInnerHTML={{ __html: `<span style="color:#4caf50;flex-shrink:0;margin-top:1px">✓</span>${f}` }}
            />
          ))}
        </div>

        {/* Terms tick */}
        <label style={{ display: "flex", gap: 10, alignItems: "flex-start", cursor: "pointer", marginBottom: 22 }}>
          <input
            type="checkbox"
            checked={agreed}
            onChange={e => setAgreed(e.target.checked)}
            style={{ marginTop: 3, width: 16, height: 16, accentColor: "#4caf50", flexShrink: 0, cursor: "pointer" }}
          />
          <span style={{ fontSize: 12, color: "#888", lineHeight: 1.65 }}>
            I agree to the{" "}
            <a
              href="/tubescan/terms-and-privacy.html"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#7bb8e8", textDecoration: "underline" }}
              onClick={e => e.stopPropagation()}
            >
              Terms, Conditions, and Privacy Policy
            </a>
            , and consent to the data sharing and tracking practices.
          </span>
        </label>

        {/* Primary CTA */}
        <button
          disabled={!agreed}
          onClick={accept}
          style={{
            width: "100%", padding: "13px 0", border: "none", borderRadius: 10,
            background: agreed ? "#4caf50" : "#1a2a1a",
            color: agreed ? "#fff" : "#3a5a3a",
            fontWeight: 700, fontSize: 15,
            cursor: agreed ? "pointer" : "default",
            fontFamily: "inherit",
            transition: "background 0.2s, color 0.2s",
            letterSpacing: "0.01em",
          }}
        >
          Sign up
        </button>

        <button
          onClick={onClose}
          style={{
            width: "100%", marginTop: 10, padding: "11px 0",
            border: "1px solid #2a2a2a", borderRadius: 10,
            background: "transparent", color: "#555",
            fontWeight: 500, fontSize: 13, cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
